import Moment from "moment";
export const formatearFecha = (start: string) => {
  try {
    // Eliminar texto no deseado como "(Convertido)"
    const cleanedStart = start.replace(/\s*\(.*?\)$/, ""); // Limpia el texto entre paréntesis al final

    // Intentar convertir la fecha usando Moment.js
    let fecha = Moment(cleanedStart).format("yyyy/MM/DD HH:mm:ss");

    // Validar si Moment devuelve una fecha válida
    if (fecha === "Invalid date") {
      fecha = "0000/00/00 00:00:00"; // Valor por defecto si no es válido
    }

    return fecha;
  } catch (error) {
    // Manejar errores inesperados
    //console.error("Error al formatear la fecha:", error);
    return "0000/00/00 00:00:00"; // Retornar un valor por defecto en caso de error
  }
};

export const formatearFechaResolverCustombkp = (start: string): string => {
  try {
    // Limpiar texto adicional como "(Convertido)"
    const cleanedStart = start.replace(/\s*\(.*?\)$/, "");

    // Detectar si el formato es DD/MM/YYYY HH:mm:ss o el estándar ISO
    const isDayFirst = /^\d{2}\/\d{2}\/\d{4}/.test(cleanedStart);

    // Validar y convertir la fecha al formato 'YYYY-MM-DDTHH:mm:ss'
    const formattedDate = isDayFirst
      ? Moment(cleanedStart, "DD/MM/YYYY HH:mm:ss", true)
      : Moment(cleanedStart, "YYYY-MM-DD HH:mm:ss", true);

    if (!formattedDate.isValid()) {
      return "Fecha inválida";
    }

    // Convertir al formato 'YYYY-MM-DDTHH:mm:ss'
    return formattedDate.format("YYYY-MM-DDTHH:mm:ss");
  } catch (error) {
    console.error("Error al resolver la fecha:", error);
    return "Fecha inválida";
  }
};

export const formatearFechaResolverCustom = (start: string): string => {
  try {
    // 1. Limpiar texto adicional como "(Convertido)"
    const cleanedStart = start.replace(/\s*\(.*?\)$/, "");

    // 2. Definir todos los formatos de entrada posibles
    // Moment intentará validar uno por uno en este orden
    const formatosEntrada = [
      "DD/MM/YYYY HH:mm:ss",
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss", // <--- Esto soluciona tu error actual
      Moment.ISO_8601        // <--- Esto añade soporte para cualquier variante ISO
    ];

    // 3. Validar y convertir
    // El tercer parámetro 'true' activa el modo estricto para los formatos de la lista
    const formattedDate = Moment(cleanedStart, formatosEntrada, true);

    if (!formattedDate.isValid()) {
      return "Fecha inválida";
    }

    // 4. Convertir al formato de salida deseado 'YYYY-MM-DDTHH:mm:ss'
    return formattedDate.format("YYYY-MM-DDTHH:mm:ss");
  } catch (error) {
    console.error("Error al resolver la fecha:", error);
    return "Fecha inválida";
  }
};

export const formatearFechaCustom = (start: string) => {
  try {
    // Eliminar texto adicional como "(Convertido)"
    const cleanedStart = start.replace(/\s*\(.*?\)$/, ""); // Limpia el texto entre paréntesis al final

    // Detectar si el formato es DD/MM/YYYY HH:mm:ss o el estándar ISO
    const isDayFirst = /^\d{2}\/\d{2}\/\d{4}/.test(cleanedStart);

    // Validar la fecha utilizando Moment.js
    const isValidDate = isDayFirst
      ? Moment(cleanedStart, "DD/MM/YYYY HH:mm:ss", true).isValid()
      : Moment(cleanedStart, "YYYY-MM-DD HH:mm:ss", true).isValid();

    if (!isValidDate) {
      return "Fecha inválida";
    }

    // Retornar la fecha original, pero validada
    return cleanedStart;
  } catch (error) {
    //console.error("Error al formatear la fecha:", error);
    return "Fecha inválida";
  }
};


export const formatearFechaInicioFin = (start: string) => {
  "01/11/2023 12:38:22";

  let fecha = Moment(start).format("yyyy/MM/DD  HH:mm:ss");
  if (fecha === "Invalid date") {
    fecha = "0000/00/00 00:00:00";
  }

  return fecha;
};

export const formatearUltAct = (start: string) => {
  "01/11/2023 12:38:22";

  let fecha = Moment(start).format("DD/MM/yyyy  HH:mm:ss");
  if (fecha === "Invalid date") {
    fecha = "00/00/0000 00:00:00";
  }

  return fecha;
};
export function formatearFechaBonita(fecha: Date): string {
  const anio = fecha.getFullYear();
  const mes = padZero(fecha.getMonth() + 1);
  const dia = padZero(fecha.getDate());
  const horas = padZero(fecha.getHours());
  const minutos = padZero(fecha.getMinutes());
  const segundos = padZero(fecha.getSeconds());
  const milisegundos = padZero(fecha.getMilliseconds(), 3);

  return `${anio}-${mes}-${dia}T${horas}:${minutos}:${segundos}.${milisegundos}`;

  //return `${anio}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
}

function padZero(valor: number, longitud: number = 2): string {
  return valor.toString().padStart(longitud, "0");
}

export const formatearFechaMascara = (start: string, mascara: string) => {
  let fechaMascara = Moment(start).format(mascara);
  if (fechaMascara === "Invalid date") {
    fechaMascara = "0000/00/00 00:00:00";
  }

  return fechaMascara;
};
export const formatearNumber = (start: string, mascara: string) => {
  let number = Number(start);
  return number;
};

/**
 * Reordena los componentes de una fecha string de un formato a otro.
 * Ejemplo por defecto: "24/05/2026 02:59:00" → "2026/05/24 02:59:00"
 *
 * @param fechaStr - String con la fecha a convertir.
 * @param mascaraEntrada - Formato de entrada (por defecto "DD/MM/YYYY HH:mm:ss").
 * @param mascaraSalida - Formato de salida (por defecto "YYYY/MM/DD HH:mm:ss").
 * @returns La fecha reformateada o "Fecha inválida" si no se pudo parsear.
 */
export const formatearFechaParaVisualizacionbkp = (
  start: string,
  aplicarUTC: boolean = false
): string => {
  try {
    // Eliminar texto adicional como "(Convertido)"
    const cleanedStart = start.replace(/\s*\(.*?\)$/, "");

    // Interpretar la fecha con formato estricto
    const formattedDate = aplicarUTC
      ? Moment.utc(cleanedStart, "YYYY-MM-DD HH:mm:ss", true).local()
      : Moment(cleanedStart, "YYYY-MM-DD HH:mm:ss", true);

    if (!formattedDate.isValid()) {
      return "Fecha inválida";
    }

    // Devolver la fecha en formato DD/MM/YYYY HH:mm:ss
    return formattedDate.format("DD/MM/YYYY HH:mm:ss");
  } catch (error) {
    console.error("Error al formatear la fecha:", error);
    return "Fecha inválida";
  }
};

export const formatearFechaParaVisualizacion = (
  start: string,
  aplicarUTC: boolean = false
): string => {
  try {
    // 1. Eliminar texto adicional como "(Convertido)"
    const cleanedStart = start.replace(/\s*\(.*?\)$/, "");

    // 2. Definimos los formatos posibles que puede recibir la función
    // Incluimos el formato con 'T', con espacio y el estándar ISO8601
    const formatosAceptados = [
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss",
      "YYYY-MM-DDTHH:mm:ssZ", // Por si trae zona horaria
      Moment.ISO_8601 // Permite detectar formatos ISO estándar automáticamente
    ];

    // 3. Interpretar la fecha
    const formattedDate = aplicarUTC
      ? Moment.utc(cleanedStart, formatosAceptados, true).local()
      : Moment(cleanedStart, formatosAceptados, true);

    if (!formattedDate.isValid()) {
      return "Fecha inválida";
    }

    // 4. Devolver la fecha en formato DD/MM/YYYY HH:mm:ss
    return formattedDate.format("DD/MM/YYYY HH:mm:ss");
  } catch (error) {
    console.error("Error al formatear la fecha:", error);
    return "Fecha inválida";
  }
};
export const obtenerTimeZoneMin = (): number => {
  // Ejemplo:
  // Argentina (UTC-3) => 180
  // España verano (UTC+2) => -120
  return new Date().getTimezoneOffset();
};


export const reordenarFormatoFecha = (
  fechaStr: string,
  mascaraEntrada: string = "DD/MM/YYYY HH:mm:ss",
  mascaraSalida: string = "YYYY/MM/DD HH:mm:ss",
  esUTCDeEntrada: boolean = false
): string => {
  try {
    const cleanedFecha = fechaStr.replace(/\s*\(.*?\)$/, "");

    // Si es UTC, lo parseamos como UTC y luego lo convertimos a local
    const fecha = esUTCDeEntrada
      ? Moment.utc(cleanedFecha, mascaraEntrada, true).local()
      : Moment(cleanedFecha, mascaraEntrada, true);

    if (!fecha.isValid()) {
      return "Fecha inválida";
    }

    return fecha.format(mascaraSalida);
  } catch {
    return "Fecha inválida";
  }
};


